import React from 'react';
import styles from './styles.scss';
import cn from 'classnames';

export const ColorDescription = ({ settings, colors, className }) => {
  const defaultColors = [
    {
      text: settings.get('dateTimeSelectionAvailabilityText'),
      color: '#DBF2E0',
    },
    { text: settings.get('dateTimeSelectionUnAvailabilityText'), color: '#F3C4C4' },
  ];

  const renderColors = colors || defaultColors;

  return (
    <div className={cn(styles.colorDescription, className)}>
      {renderColors.map((color) => (
        <div className={styles.colorItem}>
          <div className={styles.colorIndicator} style={{ backgroundColor: color.color }} />
          <div className={styles.description}>{color.text}</div>
        </div>
      ))}
    </div>
  );
};
